/** @deprecated 请使用 appLocale；保留导出以兼容旧引用 */
import {
  getAppLocale,
  LANDING_LOCALE_STORAGE_KEY,
  toVueI18nKey,
  type VueI18nLangKey,
} from './appLocale'

export type LandingI18nLang = VueI18nLangKey

export { LANDING_LOCALE_STORAGE_KEY }

/** 从 SSOT 读取，映射为 vue-i18n 语言键 */
export function getI18nLangFromLandingStorage(): LandingI18nLang {
  return toVueI18nKey(getAppLocale())
}
